import React from 'react';

export enum DividerOrientation {
  horizontal = 'horizontal',
  vertical = 'vertical',
}

interface DividerProps {
  orientation?: DividerOrientation;
  className?: string;
}

export default function Divider({ orientation = DividerOrientation.horizontal, className }: DividerProps) {
  switch (orientation) {
    case DividerOrientation.horizontal:
      return <div className={`h-[1px] w-full bg-gray-300 ${className}`}></div>;
    case DividerOrientation.vertical:
      return <div className={`h-full w-[1px] bg-gray-300 ${className}`}></div>;
  }
}
